import React, { useState } from 'react'
import { DataContext } from '../../../helper/HelperOne'
import NavBar from '../../nav_bar/Navbar'
import SalesOrderStatusList from './SalesOrderStatusList'

const SalesOrderStatus = () => {
    const [searchUi, setSearchUi] = useState(false)
    const [searchData, setSearchData] = useState(null)
    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<SalesOrderStatusList/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default SalesOrderStatus